var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalSub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0.5H3.2C1.44 0.5 0.016 1.94 0.016 3.7L0 32.5L6.4 26.1H28.8C30.56 26.1 32 24.66 32 22.9V3.7C32 1.94 30.56 0.5 28.8 0.5ZM28.8 22.9H5.072L4.128 23.844L3.2 24.772V3.7H28.8V22.9ZM13.6 19.7H25.6V16.5H16.8L13.6 19.7ZM19.776 10.308C20.096 9.988 20.096 9.492 19.776 9.172L16.944 6.34C16.624 6.02 16.128 6.02 15.808 6.34L6.4 15.748V19.7H10.352L19.776 10.308Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSub);
export default __webpack_public_path__ + "static/media/total-sub.1f3b13903ff2671ba1aa93020e0a8221.svg";
export { ForwardRef as ReactComponent };